import { ARROW_UP } from "./Bits";
import { GITHUB_URL, LINKEDIN_URL, RESUME_URL } from "../data";

export function Footer() {
  return (
    <footer>
      <span>Nehan Punjani / Portfolio</span>
      <span>
        <a href={GITHUB_URL} target="_blank" rel="noreferrer">
          GitHub
        </a>{" "}
        ·{" "}
        <a href={LINKEDIN_URL} target="_blank" rel="noreferrer">
          LinkedIn
        </a>{" "}
        ·{" "}
        <a href={RESUME_URL} target="_blank" rel="noreferrer">
          Résumé
        </a>
      </span>
      <span
        className="totop"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        Back to top {ARROW_UP}
      </span>
    </footer>
  );
}
